import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import FormInput from "../../components/FormInput";
import Button from "../../components/Button";
import Toast from "../../components/Toast";
import ActionLoader from "../../components/ActionLoader";
import ImageUploading from "../../components/AddEditItems/ImageUpload";

import {
  STATES_LIST,
} from "../../utils/api";

import Logo1 from "../../icons/abcattech.png";
import Logo2 from "../../icons/newicons/bottomSidebarLogo.png";
import BG from "../../icons/bg.png";

import { getToken } from "../../utils/storage";
import useIsMobile from "../../hooks/useIsMobile";

function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height,
  };
}

const normalizeInput = (value) => {
  if (!value) return value;
  const currentValue = value.replace(/[^\d]/g, "");
  const cvLength = currentValue.length;

  if (value.length > 0) {
    if (cvLength < 4) return currentValue;
    if (cvLength < 7)
      return `${currentValue.slice(0, 3)}-${currentValue.slice(3)}`;
    return `${currentValue.slice(0, 3)}-${currentValue.slice(
      3,
      6
    )}-${currentValue.slice(6, 10)}`;
  }
};

export const FranchiseSignup = (props) => {
  const isMobile = useIsMobile();
  const [companyName, setCompanyName] = useState("");
  const [companyEmail, setCompanyEmail] = useState("");
  const [companyAddress1, setCompanyAddress1] = useState("");
  const [companyAddress2, setCompanyAddress2] = useState("");
  const [companyCity, setCompanyCity] = useState("");
  const [companyState, setCompanyState] = useState("");
  const [companyZipcode, setCompanyZipcode] = useState("");
  const [companyPhone, setCompanyPhone] = useState("");
  const [primaryContactFirstName, setPrimaryContactFirstName] = useState("");
  const [primaryContactLastName, setPrimaryContactLastName] = useState("");
  const [driverLicense, setDriverLicense] = useState("");
  const [businessLicense, setBusinessLicense] = useState("");
  const [ein, setEin] = useState("");
  const [companyLogo, setCompanyLogo] = useState(Logo1);
  const [companyLogoImage, setCompanyLogoImage] = useState(null);
  const [metalRecyclerLicense, setMetalRecyclerLicense] = useState(null);

  const [toastParams, setToastParams] = useState({
    message: "",
    type: "",
    id: "",
  });

  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );
  const [isLoading, setIsLoading] = useState(false);
  const [hasSubmitted, setHasSubmitted] = useState(false);

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const setLogo1 = () => {
    const hostname = window.location.hostname;
    const isAllowedHost = hostname.includes("cattraders.com");
    if (isAllowedHost) {
      setCompanyLogo(null);
    } else {
      setCompanyLogo(Logo1);
    }
  };

  useEffect(() => {
    setLogo1();
  }, []);

  const validateFields = () => {
    if (!companyName) {
      setToastParams({
        type: "ERROR",
        message: "Company Name is required",
        id: new Date().getTime(),
      });
      return false;
    }
    if (!companyAddress1) {
      setToastParams({
        type: "ERROR",
        message: "Company Address 1 is required",
        id: new Date().getTime(),
      });
      return false;
    }
    if (!companyCity) {
      setToastParams({
        type: "ERROR",
        message: "Company City is required",
        id: new Date().getTime(),
      });
      return false;
    }
    if (!companyState) {
      setToastParams({
        type: "ERROR",
        message: "Company State is required",
        id: new Date().getTime(),
      });
      return false;
    }
    if (!companyZipcode) {
      setToastParams({
        type: "ERROR",
        message: "Company Zipcode is required",
        id: new Date().getTime(),
      });
      return false;
    }
    if (!primaryContactFirstName) {
      setToastParams({
        type: "ERROR",
        message: "Primary Contact First Name is required",
        id: new Date().getTime(),
      });
      return false;
    }
    if (!primaryContactLastName) {
      setToastParams({
        type: "ERROR",
        message: "Primary Contact Last Name is required",
        id: new Date().getTime(),
      });
      return false;
    }
    return true;
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    setHasSubmitted(true);

    if (!validateFields()) {
      return;
    }

    // TODO: Integrate with API later
    // For now, just redirect to login page
    props.history.push("/");
  };

  return (
    <div
      className=""
      style={{
        backgroundImage: `url(${BG})`,
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        width: "100vw",
        height: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "20px",
        pointerEvents: isLoading ? "none" : "auto",
      }}
    >
      <style>{`
        .franchise-signup-form .forminput-wrap .placeholder {
          margin-bottom: 4px !important;
        }
      `}</style>
      <div style={{ position: "relative", width: "100%", maxWidth: "1000px" }}>
        <div className="bg-black box-shadow op-7" style={{ 
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          height: "650px",
          width: "100%",
          borderRadius: "30px"
        }}></div>
        <form
          onSubmit={onSubmit}
          className="franchise-signup-form"
          style={{
            padding: "25px 40px",
            borderRadius: "30px",
            width: "100%",
            margin: "0 auto",
            position: "relative",
            zIndex: 1,
            backgroundColor: "#fff",
            boxShadow: "0 5px 10px rgba(0, 0, 0, 0.3)",
          }}
        >
          <div className="t-center mb-20">
            {companyLogo && (
              <img src={companyLogo} className="wt-150 ht-60 mb-12" alt="Company Logo" />
            )}
            <img src={Logo2} className="wt-150" alt="CATTRADER Logo" />
          </div>

          <div>
            {/* Three Column Layout */}
            <div
              className={`flex flex-between ${isMobile ? "flex-column" : ""}`}
              style={{ gap: "20px", marginBottom: "20px" }}
            >
              {/* Column 1: Company Name, Company Email, Company Address 1, Select Company State, Business License */}
              <div className={`${!isMobile ? "wt-32p" : "wt-100p"}`} style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                <FormInput
                  inputClassName="rounded-pill bg-blue"
                  placeholder={
                    <div
                      dangerouslySetInnerHTML={{
                        __html: `Company Name <span style='color:red;'>*</span>`,
                      }}
                    ></div>
                  }
                  onChange={(e) => {
                    setCompanyName(e.target.value);
                  }}
                  className="wt-100p"
                  value={companyName}
                  hasError={hasSubmitted && !companyName}
                />
                <FormInput
                  inputClassName="rounded-pill bg-blue"
                  placeholder="Company Email"
                  onChange={(e) => {
                    setCompanyEmail(e.target.value);
                  }}
                  className="wt-100p"
                  value={companyEmail}
                  type="email"
                />
                <FormInput
                  inputClassName="rounded-pill bg-blue"
                  placeholder={
                    <div
                      dangerouslySetInnerHTML={{
                        __html: `Company Address 1 <span style='color:red;'>*</span>`,
                      }}
                    ></div>
                  }
                  onChange={(e) => {
                    setCompanyAddress1(e.target.value);
                  }}
                  className="wt-100p"
                  value={companyAddress1}
                  hasError={hasSubmitted && !companyAddress1}
                />
                <div className="wt-100p">
                  <div className="c-gray fs-14" style={{ marginBottom: "4px" }}>
                    Select Company State <span style={{ color: "red" }}>*</span>
                  </div>
                  <select
                    name="companyState"
                    className="select font-primary fs-14 fw-bolder rounded-pill bg-blue"
                    value={companyState}
                    onChange={(e) => {
                      setCompanyState(e.target.value);
                    }}
                    style={{ width: "100%" }}
                  >
                    <option value="">Select Company State</option>
                    {(STATES_LIST || []).map((stateOption) => {
                      return (
                        <option key={stateOption} value={stateOption}>
                          {stateOption}
                        </option>
                      );
                    })}
                  </select>
                  {hasSubmitted && !companyState && (
                    <div className="fs-10 c-error fw-bold p-absolute">
                      Please select valid state
                    </div>
                  )}
                </div>
                <FormInput
                  inputClassName="rounded-pill bg-blue"
                  placeholder="Business License"
                  onChange={(e) => {
                    setBusinessLicense(e.target.value);
                  }}
                  className="wt-100p"
                  value={businessLicense}
                />
              </div>

              {/* Column 2: Primary Contact First Name, Company Phone, Company Address 2, Company Zipcode, EIN */}
              <div className={`${!isMobile ? "wt-32p" : "wt-100p"}`} style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                <FormInput
                  inputClassName="rounded-pill bg-blue"
                  placeholder={
                    <div
                      dangerouslySetInnerHTML={{
                        __html: `Primary Contact First Name <span style='color:red;'>*</span>`,
                      }}
                    ></div>
                  }
                  onChange={(e) => {
                    setPrimaryContactFirstName(e.target.value);
                  }}
                  className="wt-100p"
                  value={primaryContactFirstName}
                  hasError={hasSubmitted && !primaryContactFirstName}
                />
                <FormInput
                  inputClassName="rounded-pill bg-blue"
                  placeholder="Company Phone"
                  onChange={(e) => {
                    setCompanyPhone(normalizeInput(e.target.value));
                  }}
                  className="wt-100p"
                  value={companyPhone}
                />
                <FormInput
                  inputClassName="rounded-pill bg-blue"
                  placeholder="Company Address 2"
                  onChange={(e) => {
                    setCompanyAddress2(e.target.value);
                  }}
                  className="wt-100p"
                  value={companyAddress2}
                />
                <FormInput
                  inputClassName="rounded-pill bg-blue"
                  placeholder={
                    <div
                      dangerouslySetInnerHTML={{
                        __html: `Company Zipcode <span style='color:red;'>*</span>`,
                      }}
                    ></div>
                  }
                  onChange={(e) => {
                    if (isNaN(e.target.value)) {
                      return;
                    }
                    setCompanyZipcode((e.target.value || "").replace(/[^\d]/g, ""));
                  }}
                  className="wt-100p"
                  value={(companyZipcode || "").replace(/[^\d]/g, "")}
                  hasError={hasSubmitted && !companyZipcode}
                />
                <FormInput
                  inputClassName="rounded-pill bg-blue"
                  placeholder="EIN"
                  onChange={(e) => {
                    setEin(e.target.value);
                  }}
                  className="wt-100p"
                  value={ein}
                />
              </div>

              {/* Column 3: Primary Contact Last Name, Driver License, Company City, Company Logo, Metal Recycler License */}
              <div className={`${!isMobile ? "wt-32p" : "wt-100p"}`} style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                <FormInput
                  inputClassName="rounded-pill bg-blue"
                  placeholder={
                    <div
                      dangerouslySetInnerHTML={{
                        __html: `Primary Contact Last Name <span style='color:red;'>*</span>`,
                      }}
                    ></div>
                  }
                  onChange={(e) => {
                    setPrimaryContactLastName(e.target.value);
                  }}
                  className="wt-100p"
                  value={primaryContactLastName}
                  hasError={hasSubmitted && !primaryContactLastName}
                />
                <FormInput
                  inputClassName="rounded-pill bg-blue"
                  placeholder="Driver License"
                  onChange={(e) => {
                    setDriverLicense(e.target.value);
                  }}
                  className="wt-100p"
                  value={driverLicense}
                />
                <FormInput
                  inputClassName="rounded-pill bg-blue"
                  placeholder={
                    <div
                      dangerouslySetInnerHTML={{
                        __html: `Company City <span style='color:red;'>*</span>`,
                      }}
                    ></div>
                  }
                  onChange={(e) => {
                    setCompanyCity(e.target.value);
                  }}
                  className="wt-100p"
                  value={companyCity}
                  hasError={hasSubmitted && !companyCity}
                />
                <div>
                  <div className="c-gray fs-14" style={{ marginBottom: "4px" }}>Company Logo</div>
                  <div className="flex flex-middle">
                    <ImageUploading onChange={setCompanyLogoImage} initialImage={null} />
                  </div>
                </div>
                <div>
                  <div className="c-gray fs-14" style={{ marginBottom: "4px" }}>Metal Recycler License</div>
                  <div className="flex flex-middle">
                    <ImageUploading onChange={setMetalRecyclerLicense} initialImage={null} />
                  </div>
                </div>
              </div>
            </div>

            {/* Sign In Link and Submit Button */}
            <div className="mt-16 mb-12 t-center">
              <span className="fs-12 c-black">
                Already have an account?{" "}
                <Link to="/" className="fs-12 c-pointer c-blue">
                  Sign In
                </Link>
              </span>
            </div>
            <div className="flex flex-between flex-middle">
              <div></div>
              <Button className="btn">Enroll</Button>
            </div>
          </div>
        </form>
      </div>
      <Toast
        type={toastParams.type}
        message={toastParams.message}
        id={toastParams.id}
      />
      {isLoading && (
        <div className="fixed inset-0 bg-gray-800 bg-opacity-50 flex items-center justify-center z-50">
          <ActionLoader />
        </div>
      )}
    </div>
  );
};

export default FranchiseSignup;



